import {POST, GET} from "@/services/gateway";

const updateSettings = ({dailyNotificationsEnabled}, providerTenantType) => {
  return POST('account/update-settings', {providerTenantType, dailyNotificationsEnabled})
}

const sendEmail = (providerTenantType) => {
  return GET(`superadmin/email/updates/generate-daily-report?providerTenantType=${providerTenantType}`)
}

const getDeletedUserSettings = () => {
  return GET('account/settings/google/deleted-users')
}

const updateDeletedUserSettings = (archiveDeletedUsers) => {
  return POST('account/settings/google/deleted-users', { archiveDeletedUsers })
}

export {
  updateSettings,
  sendEmail,
  getDeletedUserSettings,
  updateDeletedUserSettings
}
